<template>
  <section>

    <div>
      <iframe
        :id="`youtube-player-${_uid}`"
        class="youtube-player"
        v-bind:src="`https://www.youtube-nocookie.com/embed/${trailers[0].videoId}?rel=0&enablejsapi=1&modestbranding=1&playsinline=1`"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen>
      </iframe>
    </div>
    <div class="youtube-trailer-buttons">
      <button
        v-for="(trailer, idx) in trailers"
        :key="idx"
        :class="{ active: activeIndex === idx }"
        data-trailer-tab-button
        @click="updateYoutubeEmbed(trailer.videoId, idx)"
      >
        {{ trailer.label }}
      </button>
    </div>
  </section>
</template>

<script>

  export default {
    name: 'youtube-trailer-switching',
    data() {
      return {
        youtubePlayer: null,
        activeIndex: 0,
        trailers: [
          // {
          //   videoId: 'xciD-Vz6T_Q',
          //   label: 'HBO Trailer',
          // },
          {
            videoId: 'huS-Ow5zq90',
            label: 'Launch Trailer',
          },
        ]
      }
    },
    created() {
      // append youtube iFrame API from https://www.youtube.com/iframe_api
      // docs: https://developers.google.com/youtube/iframe_api_reference#Getting_Started
      // Not great because it'll attach a script every component instance, but eh
      let possibleTag = document.querySelector("script[src='https://www.youtube.com/iframe_api']");
      if (!possibleTag) {
        var tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        document.head.appendChild(tag);
      }
    },
    mounted() {
      window.onYouTubeIframeAPIReady = this.initPlayer;
    },
    methods: {
      initPlayer() {
        const iframe = document.getElementById(`youtube-player-${this._uid}`);

        if(!iframe) return;

        this.youtubePlayer = new YT.Player(iframe, {
          playerVars: {
            rel: 0,
            enablejsapi: 1,
            modestbranding: 1,
            playsinline: 1,
          },
        });
      },
      updateYoutubeEmbed(videoId, index) {
        if (!this.youtubePlayer) {
          this.initPlayer();
        };

        const currentState = this.youtubePlayer.getPlayerState();
        if (currentState === YT.PlayerState.PLAYING) {
          this.youtubePlayer.pauseVideo();
        }

        this.youtubePlayer.cueVideoById(videoId);
        this.activeIndex = index;
      }
    },
  }
</script>